/**
 * Add up all values in `v`, with property selected by `picker`
 *
 * @example sum([{ a: 1 }, { a: 2 }, { z: 2 }], v => v.a); // 3
 */
export const sum = <T>(v: T[], picker: (v: T) => number, initial: number = 0): number =>
  v.reduce((acc, curr) => acc + picker(curr), initial);
